import { render } from "./waves.vue?vue&type=template&id=30757200&lang=true"
import script from "./waves.vue?vue&type=script&lang=js"
export * from "./waves.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__